/**
 * NotFoundView - 404 page for invalid routes
 */

import { Link } from 'react-router-dom';

function NotFoundView() {
    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col items-center justify-center min-h-[60vh]">
                <div className="text-center max-w-md">
                    <h1 className="text-6xl font-bold text-text-primary mb-4">404</h1>
                    <h2 className="text-2xl font-semibold text-text-primary mb-4">
                        Page Not Found
                    </h2>
                    <p className="text-text-secondary mb-8">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    <Link
                        to="/"
                        className="inline-block bg-accent-primary hover:bg-accent-hover text-white font-medium px-6 py-3 rounded-lg transition-colors duration-200"
                    >
                        Go to Collection
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default NotFoundView;
